import { Modal } from 'src/components/Modal';
import { Button } from 'src/components/Button';
import { Input } from 'src/components/Input';

type OverrideModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  closeLabel: string;
  confirmLabel: string;
  dateValue: string;
  onChange: (date: string) => void;
  onConfirm: () => void;
  confirmDisabled?: boolean;
};

export const OverrideModal = ({
  isOpen,
  onClose,
  title,
  closeLabel,
  confirmLabel,
  dateValue,
  onChange,
  onConfirm,
  confirmDisabled,
}: OverrideModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      actionButton={
        <Button onClick={onConfirm} disabled={confirmDisabled}>
          {confirmLabel}
        </Button>
      }
    >
      <div className="space-y-2">
        <label className="block text-sm font-medium text-neutral-700">
          Date
        </label>
        <Input
          type="date"
          value={dateValue}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      <div className="mt-4">
        <Button variant="outlined" onClick={onClose}>
          {closeLabel}
        </Button>
      </div>
    </Modal>
  );
};

export default OverrideModal;
